import React, { useCallback, useEffect, useRef, useState } from "react";
import { testIdProps } from "../../../../../utils/testIdProps";
import Select from "react-select";
import Styles from "./stampApiServicePopup.module.scss";
import ErrorMessage from "../../../../../Shared/error-message/errorMessage";
import dropDownStyles from "../../../../../Shared/dropDownStyles";
import InputField from "../../Shared/inputField/inputField";

import {
  buttonStyles,
  StyledButton,
} from "../../../../../Shared/button/button";

import { validName, validStateCode, isNumberOnly } from "../../../../../utils/validation";
import { stampDutyValues } from "./estampApiData";
import { callApi } from "../../../../../api/fetch";

function EstampApiPopup({ toastTimeout, handleResponse, name }: any) {
  const errorObject = {
    firstPartyNameError: "",
    secondPartyNameError: "",
    purposeOfStampDutyError: "",
    branchError: false,
    articleNumberError: false,
    stampDutyValueError: false,
    considerationPriceError: false,
    numberOfCopiesError: false,
    consentError: false,
    estampDutyPaidByError: false,
  };

  const firstPartyNameRef = useRef<any>(null);
  const secondPartyNameRef = useRef<any>(null);
  const purposeOfStampDutyRef = useRef<any>(null);
  const considerationPriceRef = useRef<any>(null);
  const [branchData, setBranchData] = useState<any>();
  const [stampDutyPaidby, setStampDutyPaidBy] = useState<any>();
  const [branch, setBranch] = useState<any>([]);
  const [articles, setArticles] = useState<any>([]);
  const [stampDutyValue, setStampDutyValue] = useState<any>();
  const estampDutyValue = [
    { name: "First Party", value: "FIRST_PARTY" },
    { name: "Second Party", value: "SECOND_PARTY" },
  ];

  const [isPaymentRequired, setIsPaymentRequired] = useState(false);
  const [selectedArticle, setSelectedArticle] = useState<any>(null);

  const [loading, setLoading] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true);
  const [error, setError] = useState({ ...errorObject });
  const [loadingForBranch, setLoadingForBranch] =
    useState<boolean>(false);
  const [loadingForArticles, setLoadingForArticles] =
    useState<boolean>(false);

  function isValidName(fieldName: string) {
    let name: string = "";
    if (fieldName === "firstPartyName") {
      name = firstPartyNameRef.current.value;
    } else if (fieldName === "secondPartyName") {
      name = secondPartyNameRef.current.value;
    } else if (fieldName === "purposeOfStampDuty") {
      name = purposeOfStampDutyRef.current.value;
    }

    if (name.length > 50) {
      return { isValid: false, message: "must not exceed 50 characters" };
    }

    return validName(name)
      ? { isValid: true, message: "" }
      : { isValid: false, message: "is invalid" };
  }

  const getBranches = useCallback(async () => {
    setLoadingForBranch(true);
    try {
      const response = await callApi(`/estamp/getBranches`, {
        method: "GET",
      });

      const rows = Array.isArray(response)
        ? response
        : Array.isArray((response as { data?: unknown })?.data)
          ? (response as { data: unknown[] }).data
          : [];
      setBranch(rows);
    } catch (err) {
      setBranch([]);
      toastTimeout(true, "error", (err as Error).message);
    } finally {
      setLoadingForBranch(false);
    }
  }, [toastTimeout]);

  useEffect(() => {
    getBranches();
  }, [getBranches]);

  const getArticles = useCallback(async () => {
    setLoadingForArticles(true);
    try {
      const stateCode = branchData?.code;
      if (!validStateCode(stateCode)) {
        setArticles([]);
        toastTimeout(true, "error", "State code must contain only letters");
        setLoadingForArticles(false);
        return;
      }
      const response = await callApi(`/estamp/articles/${stateCode}`, {
        method: "GET",
      });
      // Always set articles to an array (empty if no data)
      setArticles(
        Array.isArray(response?.data)
          ? response.data
          : Array.isArray(response)
            ? response
            : []
      );
      setLoadingForArticles(false);
    } catch (err) {
      setArticles([]); // Clear articles on error
      toastTimeout(true, "error", (err as Error).message);
      setLoadingForArticles(false);
    }
  }, [branchData?.code, toastTimeout]);

  useEffect(() => {
    if (branchData?.id) {
      getArticles();
    }
  }, [branchData?.id, getArticles]);

  useEffect(() => {
    setSelectedArticle(null);
  }, [branchData?.id]);

  const branchList = Array.isArray(branch)
    ? branch.map((obj: any) => ({
        label: obj.constitutionName || obj.name,
        value: obj.id ?? obj.code,
        stateCode: obj.code,
      }))
    : [];

  function handleBranchData(val: any) {
    const branchInfo = branch.find(
      (obj: any) => obj.id === val || obj.code === val
    );
    setBranchData(branchInfo);
    return;
  }

  // conditions to check Run verification button should be enabled or disabled
  useEffect(() => {
    try {
      if (
        !validName(firstPartyNameRef.current.value) ||
        !validName(secondPartyNameRef.current.value) ||
        !validName(purposeOfStampDutyRef.current.value) ||
        !isNumberOnly(considerationPriceRef.current.value) ||
        !firstPartyNameRef.current.value ||
        !secondPartyNameRef.current.value ||
        !purposeOfStampDutyRef.current.value ||
        !(branchData?.name || branchData?.constitutionName) ||
        !stampDutyValue ||
        !considerationPriceRef.current.value ||
        error.firstPartyNameError ||
        error.secondPartyNameError ||
        error.purposeOfStampDutyError ||
        error.branchError ||
        error.articleNumberError ||
        error.stampDutyValueError ||
        error.considerationPriceError ||
        error.consentError ||
        error.estampDutyPaidByError ||
        !stampDutyPaidby
      ) {
        setIsDisabled(true);
      } else {
        setIsDisabled(false);
      }
    } catch (err) {
      setIsDisabled(true);
      toastTimeout(true, "error", (err as Error).message);
    }
  }, [error]);

  useEffect(() => {
    const myDiv: any = document.getElementById("input-article-estamp-8000");
    myDiv.addEventListener("click", function () {
      if (!branchData) {
        setError((error) => ({
          ...error,
          branchError: true,
        }));
      } else if (branchData) {
        setError((error) => ({
          ...error,
          branchError: false,
        }));
      }
    });
  }, [branchData]);

  function handleCheck() {
    const firstPartyName = firstPartyNameRef.current.value;
    const secondPartyName = secondPartyNameRef.current.value;
    const purposeOfStampDuty = purposeOfStampDutyRef.current.value;
    const considerationPrice = considerationPriceRef.current.value;
    const articleId =
      selectedArticle ||
      articles[0]?.id ||
      articles[0]?.article_code ||
      "";

    const consent = isChecked === true ? "Y" : "N";

    if (!validName(firstPartyName)) {
      setError((error) => ({
        ...error,
        firstPartyNameError: "First Party Name is Invalid",
      }));
      return false;
    } else if (!validName(secondPartyName)) {
      setError((error) => ({
        ...error,
        secondPartyNameError: "Second Party Name is Invalid",
      }));
      return false;
    } else if (!validName(purposeOfStampDuty)) {
      setError((error) => ({
        ...error,
        purposeOfStampDutyError: "Purpose of Stamp Duty is Invalid",
      }));
      return false;
    } else if (!(branchData?.name || branchData?.constitutionName)) {
      setError((error) => ({
        ...error,
        branchError: true,
      }));
      return false;
    } else if (!validStateCode(branchData?.code)) {
      setError((error) => ({
        ...error,
        branchError: true,
      }));
      toastTimeout(true, "error", "State code must contain only letters");
      return false;
    } else if (!stampDutyValue) {
      setError((error) => ({
        ...error,
        stampDutyValueError: true,
      }));
      return false;
    } else if (!considerationPrice) {
      setError((error) => ({
        ...error,
        considerationPriceError: true,
      }));
      return false;
    } else if (!stampDutyPaidby) {
      setError((error) => ({
        ...error,
        estampDutyPaidByError: true,
      }));
      return false;
    } else if (!isChecked) {
      setError((error) => ({
        ...error,
        consentError: true,
      }));
      return false;
    }
    setLoading(true);
    handleResponse(
      {
        stateCode: branchData?.code,
        firstPartyName: firstPartyName,
        secondPartyName: secondPartyName,
        stampDutyPaidBy: stampDutyPaidby?.value,
        stampDutyAmount: stampDutyValue,
        stampType: "ESTAMP",
        articleId: articleId,
        purpose: purposeOfStampDuty,
        considerationPrice: considerationPrice,
        PaymentRequired: `${isPaymentRequired}`,
        consent: consent,
      },
      setLoading
    );
  }

  return (
    <div className={`${Styles.Content}`}>
      <div className={`${Styles.infoForm} w-full `}>
        <hr />
        <p className="mt-4 ml-2">
          Fill in the below details to run verification
        </p>
        <div className="d-flex flex-column">
          <div className="d-flex flex-row justify-content-between">
            <div className="d-flex flex-grow-1 flex-column mx-2">
              <div className={`${Styles.inputContent} d-flex flex-column`}>
                <label className={`${Styles.label}`}>
                  First Party Name <span className={Styles.mandatory}>*</span>
                </label>
                <InputField
                  id="id-input-first-party-name"
                  text="lowercase"
                  onChange={() => {
                    const validation = isValidName("firstPartyName");
                    setError({
                      ...error,
                      firstPartyNameError: validation.isValid
                        ? ""
                        : `First Party Name ${validation.message}`,
                    });
                  }}
                  style={{ width: "100%" }}
                  inputRef={firstPartyNameRef}
                  isError={!!error.firstPartyNameError}
                  purpose="forPassport"
                />
                {error.firstPartyNameError && (
                  <ErrorMessage>{error.firstPartyNameError}</ErrorMessage>
                )}
              </div>
              <div className={`${Styles.inputContent} d-flex flex-column mt-2`}>
                <label className={`${Styles.label}`}>
                  Stamp Duty Paid By <span className={Styles.mandatory}>*</span>
                </label>
                <Select
                  id="id-input-article-number"
                  onChange={(e: any) => {
                    setStampDutyPaidBy({
                      ...stampDutyPaidby,
                      value: e?.value,
                    });
                    setError({
                      ...error,
                      estampDutyPaidByError: false,
                    });
                  }}
                  options={estampDutyValue?.map((estamp: any) => {
                    return {
                      label: estamp?.name,
                      value: estamp?.value,
                    };
                  })}
                  styles={
                    !error.estampDutyPaidByError
                      ? dropDownStyles.customStylesForCountry
                      : dropDownStyles.customStylesForCountryError
                  }
                  placeholder=""
                />
                {error.estampDutyPaidByError && (
                  <ErrorMessage>please select estamp duty paid by</ErrorMessage>
                )}
              </div>
              <div className={`${Styles.inputContent} d-flex mt-2 flex-column`}>
                <label className={`${Styles.label}`}>
                  State <span className={Styles.mandatory}>*</span>
                </label>
                <Select
                  id="id-input-state"
                  onChange={(e: any) => {
                    handleBranchData(e?.value);
                    setError({ ...error, branchError: false });
                  }}
                  options={
                    branchList && branchList.length > 0 ? branchList : []
                  }
                  styles={
                    !error.branchError
                      ? dropDownStyles.customStylesForCountry
                      : dropDownStyles.customStylesForCountryError
                  }
                  placeholder={
                    loadingForBranch
                      ? "Loading states..."
                      : branchList && branchList.length === 0
                        ? "No states found"
                        : "Select State"
                  }
                  isLoading={loadingForBranch}
                  noOptionsMessage={() =>
                    loadingForBranch
                      ? "Loading..."
                      : branchList && branchList.length === 0
                        ? "No data"
                        : "No options"
                  }
                />
                {error.branchError && (
                  <ErrorMessage>Please select state first</ErrorMessage>
                )}
              </div>

              <div className={`${Styles.inputContent} d-flex mt-2 flex-column`}>
                <label className={`${Styles.label}`}>
                  Stamp Duty Value <span className={Styles.mandatory}>*</span>
                </label>
                <Select
                  id="id-input-stamp-duty-value"
                  onChange={(e: any) => {
                    setStampDutyValue(e.value);
                    setError({
                      ...error,
                      stampDutyValueError: false,
                    });
                  }}
                  options={stampDutyValues}
                  styles={
                    !error.stampDutyValueError
                      ? dropDownStyles.customStylesForCountry
                      : dropDownStyles.customStylesForCountryError
                  }
                  placeholder={
                    loadingForBranch
                      ? "Loading values..."
                      : stampDutyValues.length === 0
                        ? "No values found"
                        : "Select Stamp Duty Value"
                  }
                  isLoading={loadingForBranch}
                  noOptionsMessage={() =>
                    loadingForBranch
                      ? "Loading..."
                      : stampDutyValues.length === 0
                        ? "No values found"
                        : "No options"
                  }
                />
                {error.stampDutyValueError && (
                  <ErrorMessage>Stamp Duty Value field is Invalid</ErrorMessage>
                )}
              </div>
            </div>
            <div className="d-flex flex-grow-1 flex-column mx-2">
              <div className={`${Styles.inputContent} d-flex flex-column`}>
                <label className={`${Styles.label}`}>
                  Second Party Name <span className={Styles.mandatory}>*</span>
                </label>
                <InputField
                  id="id-input-second-party-name"
                  text="lowercase"
                  onChange={() => {
                    const validation = isValidName("secondPartyName");
                    setError({
                      ...error,
                      secondPartyNameError: validation.isValid
                        ? ""
                        : `Second Party Name ${validation.message}`,
                    });
                  }}
                  style={{ width: "100%" }}
                  inputRef={secondPartyNameRef}
                  isError={!!error.secondPartyNameError}
                  purpose="forPassport"
                />
                {error.secondPartyNameError && (
                  <ErrorMessage>{error.secondPartyNameError}</ErrorMessage>
                )}
              </div>
              <div className={`${Styles.inputContent} d-flex mt-2 flex-column`}>
                <label className={`${Styles.label}`}>
                  Purpose of Stamp Duty{" "}
                  <span className={Styles.mandatory}>*</span>
                </label>
                <InputField
                  id="id-input-purpose-of-stamp-duty"
                  text="lowercase"
                  onChange={() => {
                    const validation = isValidName("purposeOfStampDuty");
                    setError({
                      ...error,
                      purposeOfStampDutyError: validation.isValid
                        ? ""
                        : `Purpose of stamp duty ${validation.message}`,
                    });
                  }}
                  style={{ width: "100%" }}
                  inputRef={purposeOfStampDutyRef}
                  isError={error.purposeOfStampDutyError}
                  purpose="forPassport"
                />
                {error.purposeOfStampDutyError && (
                  <ErrorMessage>{error.purposeOfStampDutyError}</ErrorMessage>
                )}
              </div>
              <div
                className={`${Styles.inputContent} d-flex mt-2 flex-column`}
                id="input-article-estamp-8000"
              >
                <label className={`${Styles.label}`}>
                  Article <span className={Styles.mandatory}>*</span>
                </label>
                <Select
                  id="input-article-estamp"
                  // value={
                  //   articles?.find((a: any) => a.id === selectedArticle?.id)
                  //     ? {
                  //         label: articles?.find(
                  //           (a: any) => a?.id === selectedArticle?.id
                  //         )?.number,
                  //         value: selectedArticle,
                  //       }
                  //     : null
                  // }
                  onChange={(e: any) => {
                    setSelectedArticle(e?.value);
                    setError({
                      ...error,
                      articleNumberError: false,
                    });
                  }}
                  options={
                    Array.isArray(articles)
                      ? articles.map((article: any) => ({
                          label:
                            article.number ||
                            article.article_code ||
                            article.article_name ||
                            article.description,
                          value: article.id || article.article_code,
                        }))
                      : []
                  }
                  styles={
                    !error.articleNumberError
                      ? dropDownStyles.customStylesForCountry
                      : dropDownStyles.customStylesForCountryError
                  }
                  placeholder={
                    loadingForArticles
                      ? "Loading articles..."
                      : articles.length === 0
                        ? "No articles found"
                        : "Select Article"
                  }
                  isDisabled={!branchData || loadingForArticles}
                  isLoading={loadingForArticles}
                  noOptionsMessage={() =>
                    loadingForArticles
                      ? "Loading..."
                      : articles.length === 0
                        ? "No articles found"
                        : "No options"
                  }
                />
                {error.articleNumberError && (
                  <ErrorMessage>
                    Please enter a valid article number
                  </ErrorMessage>
                )}
              </div>
              <div className={`${Styles.inputContent} d-flex mt-2 flex-column`}>
                <label className={`${Styles.label}`}>
                  Consideration Price{" "}
                  <span className={Styles.mandatory}>*</span>
                </label>
                <InputField
                  style={{ width: "100%" }}
                  type="text"
                  id="id-input-consideration-price"
                  onChange={() => {
                    setError({
                      ...error,
                      considerationPriceError: !isNumberOnly(
                        considerationPriceRef.current.value
                      ),
                    });
                  }}
                  inputRef={considerationPriceRef}
                  isError={error.considerationPriceError}
                  purpose="forPassport"
                />
                {error.considerationPriceError && (
                  <ErrorMessage>
                    Consideration Price field is Invalid
                  </ErrorMessage>
                )}
              </div>
              <div
                className={`${Styles.inputContent} d-flex mt-4 pt-2 flex-column`}
              ></div>
            </div>
          </div>

          <p
            className={`${Styles.ackText} mb-0`}
            style={{ marginTop: "20px", marginLeft: "6px", maxWidth: "90%" }}
          >
            <span className={Styles.mandatory}>*</span> A dummy Estamp is
            generated for testing purpose. The dummy Estamp generated on trail
            center is NOT legally valid
          </p>

          <div className="pl-4 py-1 d-flex flex-column">
            <div className="d-flex align-items-center gap- mt-4 mb-3">
              <input {...testIdProps("consent-checkbox-estamp-api")}
                required
                type="checkbox"
                className={`${Styles.formCheckInput}`}
                onChange={(e: any) => setIsChecked(e.target.checked)}
                style={error.consentError ? { border: "1px solid red" } : {}}
              />
              <p
                className={`${Styles.ackText} mb-0`}
                style={{
                  flexGrow: 1,
                  flexShrink: 1,
                  minWidth: 0,
                  marginLeft: "5px",
                }}
              >
                I hereby agree, to let zoop.one verify my data for verification
              </p>
            </div>
            {error.consentError && (
              <ErrorMessage>Please provide consent!</ErrorMessage>
            )}
          </div>
          <div className={`${Styles.buttonGroup}`}>
            <StyledButton
              id="id-submit-button-estamp"
              hoverStyle={{ ...buttonStyles.primary.hover }}
              disabled={isDisabled || loading}
              isLoading={loading}
              style={{ ...buttonStyles.primary.normal }}
              onClick={() => {
                setTimeout(() => setError({ ...error }), 2000);
                handleCheck();
              }}
            >
              Run Verification
            </StyledButton>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EstampApiPopup;
